import styled from 'styled-components'
import { breakpoints } from '../../../../MediasQueries'

export const InfosWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  @media (max-width: ${breakpoints.sm}) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }
  margin-top: auto;
  gap: 20px;

  button {
    font-size: 15px;
  }
`

export const ContentModal = styled.div`
  margin: 0 1vw;
  -webkit-box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  box-shadow: 0 0 40px rgb(8 21 66 / 15%);
`
